import NoUsersFound from './NoUsersFound.component';

export default NoUsersFound;